import React from "react";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import StudentList from "../../components/StudentList";

const Students: React.FC = () => {
  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Students" />
          <CardContent>
            <StudentList />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Students;
